

async function switchToSubscription(button, bundleKey, planId) {
  button.innerHTML = "Upgrading...";
  const item = Rebuy.Cart.cart.items.find((item) => item.key == bundleKey);
  try {
    await Rebuy.Cart.switchToSubscription(item, planId);
  } catch (error) {
    console.error(
      "Failed to parse bundleItem or call switchToSubscription:",
      error
    );
  } finally {
    setTimeout(() => {
      renderStarterKitLineItems();
    }, 2000);
  }
}

async function renderStarterKitLineItems() {
  const { items } = await fetchCart();
  const bundlesInCart = {};
  let cartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = cartPageItemsNode.querySelectorAll(
    ".static-line-item-starter-kit"
  );
  bundleLineItems.forEach((item) => item.remove());

  // Group items by _bundle_id
  items.forEach((item) => {
    const bundleId = item.properties["_bundle_id"];
    if (bundleId) {
      if (!bundlesInCart[bundleId]) {
        bundlesInCart[bundleId] = [];
      }
      bundlesInCart[bundleId].push(item);
    }
  });

  // Render each bundle
  Object.entries(bundlesInCart).forEach(([bundleId, bundleItems]) => {
    let newBundleLineItem = document.createElement(isCartPage ? "tr" : "li");
    newBundleLineItem.id = bundleId;
    newBundleLineItem.classList.add(
      "rebuy-cart__flyout-item",
      "static-line-item",
      "static-line-item-starter-kit"
    );
    newBundleLineItem.dataset.type = "_bundle_id";

    if (isCartPage) {
      newBundleLineItem.innerHTML =
        starterKitLineItemMarkupCartPage(bundleItems);
    } else {
      newBundleLineItem.innerHTML = startKitBundleItemMarkup(bundleItems);
    }

    const addedBundleItem = document.getElementById(bundleId);
    if (!addedBundleItem && cartPageItemsNode) {
      cartPageItemsNode.append(newBundleLineItem);
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

function startKitBundleItemMarkup(bundleItems) {
  const bundleTitle =
    bundleItems.find((item) => item.product_type === "Diffuser")
      ?.product_title || "Bundle"; // Use the diffuser line item title
  const bundleVariantTitle = bundleItems.find(
    (item) => item.product_type === "Diffuser"
  )?.variant_title;
  let bundleSlashedOutPrice = bundleItems.reduce(
    (sum, bundleItem) =>
      sum +
      parseFloat(
        bundleItem.properties["_compare_at_price"] !== "0"
          ? bundleItem.properties["_compare_at_price"]
          : bundleItem.original_price || 0
      ),
    0
  );
  bundleSlashedOutPrice = formatMoney(bundleSlashedOutPrice);

  const bundleSalePrice = formatMoney(
    bundleItems.reduce((sum, bundleItem) => sum + bundleItem.final_price, 0)
  );
  const bundleOffValue = formatMoney(
    Math.round(
      ((bundleSlashedOutPrice - bundleSalePrice) / bundleSlashedOutPrice) * 100
    )
  );
  const bundleImg =
    bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")
      ?.image || "";
  const bundleUrl =
    bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")
      ?.url || "";
  const bundleQty = bundleItems[0].quantity;

  function bundleProductsTitleProp() {
    let string = "";

    bundleItems.forEach((bundleItem) => {
      if (bundleItem.product_type != "Diffuser") {
        string += `
        <div class="rebuy-cart__flyout-item-member">
          <div class="rebuy-cart__flyout-item-property">
            <span class="rebuy-cart__flyout-item-property-name">${
              bundleItem.product_type
            }</span>
            <span class="rebuy-cart__flyout-item-property-separator"> - </span>
            <span class="rebuy-cart__flyout-item-property-value">${
              bundleItem.title
            }</span>

          </div>
        </div>`;
      }
    });
    return string;
  }

  return `
      <div class="rebuy-cart__flyout-item-media">
        <a href="${bundleUrl}" tabindex="-1">
          <img src="${bundleImg} alt="${bundleTitle}"></a>
      </div>
      <div class="rebuy-cart__flyout-item-info">
        <a
          role="heading"
          aria-level="5"
          href="${bundleUrl}"
          alt="View ${bundleTitle}"
          class="rebuy-cart__flyout-item-product-title">${bundleTitle}</a>
            <div class="rebuy-cart__flyout-item-variant-title">${bundleVariantTitle}</div>
        <div class="rebuy-cart__flyout-item-discount-message">${bundleOffValue}</div>
        <div class="rebuy-cart__flyout-item-properties">
        ${bundleProductsTitleProp()}
      </div>
        <!---->
        <button
          type="button"
          alt="Remove ${bundleTitle}"
          aria-label="Remove ${bundleTitle}"
          class="rebuy-cart__flyout-item-remove line-item__remove-button">
          <i aria-hidden="true" class="far fa-trash"></i>
        </button>
        <div class="rebuy-cart__flyout-item-quantity">
          <div class="rebuy-cart__flyout-item-quantity-widget">
            <button
              alt="Decrease quantity of ${bundleTitle}"
              aria-label="Decrease quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
              <i aria-hidden="true" class="far fa-minus"></i>
            </button>
            <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
              ${bundleQty}
            </span>
            <button
              alt="Increase quantity of ${bundleTitle}"
              aria-label="Increase quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
              <i aria-hidden="true" class="far fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="rebuy-cart__flyout-item-price">
          <div>
            <span class="rebuy-money sale">
              <span class="sr-only">Sale price</span>
              <span>${bundleSalePrice}</span>
            </span>
            ${
            bundleSlashedOutPrice &&
            bundleSlashedOutPrice != "0" &&
            bundleSlashedOutPrice > bundleSalePrice ?
            `
            <span class="rebuy-money compare-at">
              <span class="sr-only">Original price</span>
              <span>${bundleSlashedOutPrice}</span>
            </span>
            ` : ``
            }

          </div>
          <!---->
        </div>
        <!---->
      </div>
  `;
}

function starterKitLineItemMarkupCartPage(bundleItems) {
  const bundleTitle =
    bundleItems.find((item) => item.product_type === "Diffuser")
      ?.product_title || "Bundle"; // Use the diffuser line item title
  const fpVariantTitle = bundleItems.find(
    (item) => item.product_type === "Diffuser"
  )?.variant_title;
  const bundleSlashedOutPrice = bundleItems.reduce(
    (sum, bundleItem) =>
      sum +
      parseFloat(
        bundleItem.properties["_compare_at_price"] !== "0"
          ? bundleItem.properties["_compare_at_price"]
          : bundleItem.original_price || 0
      ),
    0
  );

  const bundleSalePrice = bundleItems.reduce(
    (sum, bundleItem) => sum + bundleItem.final_price,
    0
  );
  const bundleOffValue = Math.round(
    ((bundleSlashedOutPrice - bundleSalePrice) / bundleSlashedOutPrice) * 100
  );
  const bundleImg =
    bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")
      ?.image || "";
  const bundleUrl =
    bundleItems.find((bundleItem) => bundleItem.product_type === "Diffuser")
      ?.url || "";
  const bundleQty = bundleItems[0].quantity;

  function bundleProductsTitleProp() {
    let string = "";
    bundleItems.forEach((bundleItem) => {
      if (bundleItem.product_type != "Diffuser") {
        string += `
        <div class="rebuy-cart__flyout-item-member">
          <div class="rebuy-cart__flyout-item-property">
            <span class="rebuy-cart__flyout-item-property-name">${
              bundleItem.product_type
            }</span>
            <span class="rebuy-cart__flyout-item-property-separator"> - </span>
            <span class="rebuy-cart__flyout-item-property-value">${
              bundleItem.title
            }</span>
             ${
               bundleItem.selling_plan_allocation
                 ? ` <p style="margin: 0;font-size: 12px;" class="rebuy-cart__flyout-item-property-value">${bundleItem.selling_plan_allocation.selling_plan.name}</p>`
                 : ""
             }
          </div>
        </div>`;
      }
    });
    return string;
  }

  return `
<td>
  <line-item class="line-item">
    <div class="line-item__media-wrapper">
      <img src="${bundleImg}" alt="${bundleTitle}" class="line-item__media rounded-xs">
      <pill-loader class="pill-loader">
        <div class="loader-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <svg class="loader-checkmark" fill="none" width="9" height="8" viewBox="0 0 9 8">
          <path d="M1 3.5 3.3 6 8 1" stroke="currentColor" stroke-width="2"></path>
        </svg>
      </pill-loader>
    </div>
    <div class="line-item__info">
      <div class="v-stack gap-0.5">
        <a href="${bundleUrl}" class="bold">
        <span class="reversed-link hover:show">${bundleTitle}</span>
        </a>
        <price-list class="price-list  ">
          <sale-price class="text-on-sale">
            <span class="sr-only">Sale price</span>${formatMoney(
              bundleSalePrice
            )}
          </sale-price>
          ${
            bundleSlashedOutPrice &&
            bundleSlashedOutPrice != "0" &&
            bundleSlashedOutPrice > bundleSalePrice ?
            `
          <compare-at-price class="text-subdued line-through">
            <span class="sr-only">Regular price</span>${formatMoney(
              bundleSlashedOutPrice
            )}
          </compare-at-price>
           ` : ``
          }
        </price-list>
      </div>
      <div class="text-sm text-subdued sm:hidden">
        <line-item-quantity class="h-stack justify-center gap-3">
          <span is="input-number" class="quantity-input quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${bundleQty}</span>
          <span class="text-xs">
          <a href="javascript:void(0)" class="link line-item__remove-button">Remove</a>
          </span>
        </line-item-quantity>
      </div>
      <ul class="contents" role="list">
      <li class="badge">
      <svg role="presentation" fill="none" focusable="false" stroke-width="1" width="14" height="13" class="icon icon-discount" viewBox="0 0 14 13">
        <path d="M7.25 11.383a1.74 1.74 0 0 0 2.195.105c.478-.35.957-.722 1.39-1.155.433-.433.804-.912 1.154-1.39.486-.662.45-1.588-.104-2.195a65.945 65.945 0 0 0-4.97-4.896 1.588 1.588 0 0 0-.75-.377c-1.017-.197-3.552-.613-4.177.012-.625.624-.208 3.16-.011 4.176.055.28.186.537.376.75a65.976 65.976 0 0 0 4.896 4.97Z" fill="none" stroke="currentColor"></path>
        <path d="M5.729 5.227a1.036 1.036 0 1 0-1.466-1.466 1.036 1.036 0 0 0 1.466 1.466Z" fill="currentColor"></path>
      </svg>
      Save ${bundleOffValue}% off sale
    </li>
      <div class="rebuy-cart__flyout-item-properties">
      <span>Bundle Products</span>
      ${bundleProductsTitleProp()}
       </div>
      </ul>
    </div>
  </line-item>
</td>
        
        <td class="hidden align-center text-center text-subdued sm:table-cell">
            <line-item-quantity class="v-stack justify-center gap-2">
            <span is="input-number" class="quantity-input quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${bundleQty}</span>
            <span class="text-xs">
                <a href="javascript:void(0)" class="link line-item__remove-button">Remove</a>
            </span>
            </line-item-quantity>
        </td>
		<td class="hidden align-center text-subdued text-end sm:table-cell">${formatMoney(
      bundleSalePrice
    )}</td>
   `;
}

// Bundles and Family Plan
async function renderBundleLineItems() {
  const { items } = await fetchCart();
  const bundlesInCart = [];
  let CartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = CartPageItemsNode.querySelectorAll(
    ".static-line-item-bundle"
  );
  bundleLineItems.forEach((item) => {
    item.remove();
  });
  items.map((item) => {
    const bundleCodeProp = item.properties["_bundle_hash"];
    if (bundleCodeProp) {
      if (!bundlesInCart.includes(bundleCodeProp)) {
        //run this block only for first item is the bundle
        bundlesInCart.push(bundleCodeProp);
        let newBundleLineItem = document.createElement("li");
        if (isCartPage) {
          newBundleLineItem = document.createElement("tr");
        }
        newBundleLineItem.id = bundleCodeProp;
        newBundleLineItem.classList.add(
          "rebuy-cart__flyout-item",
          "static-line-item",
          "static-line-item-bundle"
        );
        newBundleLineItem.dataset.type = "_bundle_hash";
        if (isCartPage) {
          newBundleLineItem.innerHTML = bundleLineItemMarkupCartPage(item);
        } else {
          newBundleLineItem.innerHTML = bundleLineItemMarkup(item);
        }
        const addedBundleItem = document.getElementById(`${bundleCodeProp}`);
        if (!addedBundleItem && CartPageItemsNode) {
          CartPageItemsNode.append(newBundleLineItem);
        }
      }
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

async function renderFpLineItems() {
  const { items } = await fetchCart();
  const bundlesInCart = [];
  let cartPageItemsNode = document.querySelector(cartItemsSelector);
  const bundleLineItems = cartPageItemsNode.querySelectorAll(
    ".static-line-item-fp"
  );
  bundleLineItems.forEach((item) => {
    item.remove();
  });
  items.map((item) => {
    const fpCodeProp = item.properties["_fp_id"];
    if (fpCodeProp) {
      if (!bundlesInCart.includes(fpCodeProp)) {
        bundlesInCart.push(fpCodeProp);
        let newBundleLineItem = document.createElement("li");
        if (isCartPage) {
          newBundleLineItem = document.createElement("tr");
        }
        newBundleLineItem.id = fpCodeProp;
        newBundleLineItem.classList.add(
          "rebuy-cart__flyout-item",
          "static-line-item",
          "static-line-item-fp"
        );
        newBundleLineItem.dataset.type = "_fp_id";
        if (isCartPage) {
          newBundleLineItem.innerHTML = fpLineItemMarkupCartPage(item);
        } else {
          newBundleLineItem.innerHTML = fpLineItemMarkup(item);
        }
        const addedBundleItem = document.getElementById(`${fpCodeProp}`);
        if (!addedBundleItem && cartPageItemsNode) {
          cartPageItemsNode.append(newBundleLineItem);
        }
      }
    }
  });
  setTimeout(() => {
    attachELToLineItem();
  }, 2000);
}

function fpLineItemMarkupCartPage(item) {
  const fpTitle = "Family Plan";
  const fpSlashedOutPrice = item.properties["_fp_slashed_out_price"];
  const fpSalePrice = item.properties["_fp_sale_price"];
  let fpOffValue = item.properties["_fp_off_value"];
  const fpImg = item.properties["_fp_img"];
  const fpUrl = item.properties["_fp_url"];

  function fpProductsTitleProp(item) {
    let string = "";

    if (item.properties["_fq_products"]) {
      item.properties["_fq_products"].forEach((productGroup, index) => {
        string += `
			<div class="rebuy-cart__flyout-item-member">
			  <h4>Member ${index + 1}</h4>
			  <div class="rebuy-cart__flyout-item-property">
				<span class="rebuy-cart__flyout-item-property-name">Diffuser</span>
				<span class="rebuy-cart__flyout-item-property-separator"> - </span>
				<span class="rebuy-cart__flyout-item-property-value">${
          productGroup.product_title
        }</span>
			  </div>
			  <div class="rebuy-cart__flyout-item-property">
				<span class="rebuy-cart__flyout-item-property-name">Oil</span>
				<span class="rebuy-cart__flyout-item-property-separator"> - </span>
				<span class="rebuy-cart__flyout-item-property-value">${
          productGroup.addon_title
        }</span>
			  </div>
			</div>`;
      });
    }

    return string;
  }

  return `
    <td>
      <line-item class="line-item">
        <div class="line-item__media-wrapper">
          <img src="${fpImg}" alt="${fpTitle}" class="line-item__media rounded-xs">
          <pill-loader class="pill-loader">
            <div class="loader-dots">
              <span></span>
              <span></span>
              <span></span>
            </div>
            <svg class="loader-checkmark" fill="none" width="9" height="8" viewBox="0 0 9 8">
              <path d="M1 3.5 3.3 6 8 1" stroke="currentColor" stroke-width="2"></path>
            </svg>
          </pill-loader>
        </div>
        <div class="line-item__info">
          <div class="v-stack gap-0.5">
            <a href="${fpUrl}" class="bold">
            <span class="reversed-link hover:show">${fpTitle}</span>
            </a>
            <price-list class="price-list  ">
              <sale-price class="text-on-sale">
                <span class="sr-only">Sale price</span>${formatMoney(
                  fpSalePrice
                )}
              </sale-price>
              <compare-at-price class="text-subdued line-through">
                <span class="sr-only">Regular price</span>${formatMoney(
                  fpSlashedOutPrice
                )}
              </compare-at-price>
            </price-list>
          </div>
          <div class="text-sm text-subdued sm:hidden">
            <line-item-quantity class="h-stack justify-center gap-3">
            <span is="input-number" class="quantity-input quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
              item.quantity
            }</span>
              <span class="text-xs">
              <a href="javascript:void(0)" class="link line-item__remove-button">Remove</a>
              </span>
            </line-item-quantity>
          </div>
          <ul class="contents" role="list">
          <li class="badge">
          <svg role="presentation" fill="none" focusable="false" stroke-width="1" width="14" height="13" class="icon icon-discount" viewBox="0 0 14 13">
            <path d="M7.25 11.383a1.74 1.74 0 0 0 2.195.105c.478-.35.957-.722 1.39-1.155.433-.433.804-.912 1.154-1.39.486-.662.45-1.588-.104-2.195a65.945 65.945 0 0 0-4.97-4.896 1.588 1.588 0 0 0-.75-.377c-1.017-.197-3.552-.613-4.177.012-.625.624-.208 3.16-.011 4.176.055.28.186.537.376.75a65.976 65.976 0 0 0 4.896 4.97Z" fill="none" stroke="currentColor"></path>
            <path d="M5.729 5.227a1.036 1.036 0 1 0-1.466-1.466 1.036 1.036 0 0 0 1.466 1.466Z" fill="currentColor"></path>
          </svg>
          Family plan savings ${formatMoney(fpOffValue)}
        </li>
          <div class="rebuy-cart__flyout-item-properties">
          ${fpProductsTitleProp(item)}
          </div>
          </ul>
        </div>
      </line-item>
    </td>
            
    <td class="hidden align-center text-center text-subdued sm:table-cell">
        <line-item-quantity class="v-stack justify-center gap-2">
        <span is="input-number" class="quantity-input quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
          item.quantity
        }</span>
        <span class="text-xs">
            <a href="javascript:void(0)" class="link line-item__remove-button">Remove</a>
        </span>
        </line-item-quantity>
    </td>
    <td class="hidden align-center text-subdued text-end sm:table-cell">${formatMoney(
      fpSalePrice
    )}</td>
	`;
}

function fpLineItemMarkup(item) {
  const fpTitle = "Family Plan";
  const fpSlashedOutPrice = item.properties["_fp_slashed_out_price"];
  const fpSalePrice = item.properties["_fp_sale_price"];
  let fpOffValue = item.properties["_fp_off_value"];
  const fpImg = item.properties["_fp_img"];
  const fpUrl = item.properties["_fp_url"];

  function fpProductsTitleProp(item) {
    let string = "";

    if (item.properties["_fq_products"]) {
      item.properties["_fq_products"].forEach((productGroup, index) => {
        string += `
            <div class="rebuy-cart__flyout-item-member">
              <h4>Member ${index + 1}</h4>
              <div class="rebuy-cart__flyout-item-property">
                <span class="rebuy-cart__flyout-item-property-name">Diffuser</span>
                <span class="rebuy-cart__flyout-item-property-separator"> - </span>
                <span class="rebuy-cart__flyout-item-property-value">${
                  productGroup.product_title
                }</span>
              </div>
              <div class="rebuy-cart__flyout-item-property">
                <span class="rebuy-cart__flyout-item-property-name">Oil</span>
                <span class="rebuy-cart__flyout-item-property-separator"> - </span>
                <span class="rebuy-cart__flyout-item-property-value">${
                  productGroup.addon_title
                }</span>
              </div>
            </div>`;
      });
    }

    return string;
  }

  return `
        <div class="rebuy-cart__flyout-item-media">
          <a href="${fpUrl}" tabindex="-1">
            <img src="${fpImg} alt="${fpTitle}"></a>
        </div>
        <div class="rebuy-cart__flyout-item-info">
          <a
            role="heading"
            aria-level="5"
            href="${fpUrl}"
            alt="View ${fpTitle}"
            class="rebuy-cart__flyout-item-product-title">${fpTitle}</a>
          <div class="rebuy-cart__flyout-item-discount-message">Family plan savings ${formatMoney(
            fpOffValue
          )}</div>
          <div class="rebuy-cart__flyout-item-properties">
            ${fpProductsTitleProp(item)}
        </div>
          <!---->
          <button
            type="button"
            alt="Remove ${fpTitle}"
            aria-label="Remove ${fpTitle}"
            class="rebuy-cart__flyout-item-remove line-item__remove-button">
            <i aria-hidden="true" class="far fa-trash"></i>
          </button>
          <div class="rebuy-cart__flyout-item-quantity">
            <div class="rebuy-cart__flyout-item-quantity-widget">
              <button
                alt="Decrease quantity of ${fpTitle}"
                aria-label="Decrease quantity of ${fpTitle}"
                type="button"
                class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
                <i aria-hidden="true" class="far fa-minus"></i>
              </button>
              <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
                ${item.quantity}
              </span>
              <button
                alt="Increase quantity of ${fpTitle}"
                aria-label="Increase quantity of ${fpTitle}"
                type="button"
                class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
                <i aria-hidden="true" class="far fa-plus"></i>
              </button>
            </div>
          </div>
          <div class="rebuy-cart__flyout-item-price">
            <div>
              <span class="rebuy-money sale">
                <span class="sr-only">Sale price</span>
                <span>${formatMoney(fpSalePrice)}</span>
              </span>
              <span class="rebuy-money compare-at">
                <span class="sr-only">Original price</span>
                <span>${formatMoney(fpSlashedOutPrice)}</span>
              </span>
            </div>
            <!---->
          </div>
          <!---->
        </div>
    `;
}

function bundleLineItemMarkupCartPage(item) {
  const bundleCodeProp = item.properties["_bundle_hash"];
  const bundleTitle = item.properties["_bundle_title"];
  const bundleSlashedOutPrice = item.properties["_bundle_slashed_out_price"];
  const bundleSalePrice = item.properties["_bundle_sale_price"];
  let bundleOffValue = item.properties["_bundle_off_value"];
  const bundleImg = item.properties["_bundle_img"];
  const bundleUrl = item.properties["_bundle_url"];
  if (bundleOffValue.includes("(")) {
    bundleOffValue =
      bundleOffValue.split("(")[1].split(")")[0].toUpperCase() + " Sale";
  }

  function bundleProductsTitleProp(item) {
    var string = "";
    for (const [key, value] of Object.entries(
      item.properties["_bundle_products"]
    )) {
      const formattedKey =
        "Bundle " +
        key.charAt(0).toUpperCase() +
        key.slice(1).replace(/_/g, " ");
      if (key.includes("product") && value) {
        let propertyString = `
        <div class="rebuy-cart__flyout-item-property">
          <span class="rebuy-cart__flyout-item-property-value">${value}</span>
        </div>
        `;
        string = string.concat(propertyString);
      }
    }
    return string;
  }

  return `
<td>
  <line-item class="line-item">
    <div class="line-item__media-wrapper">
      <img src="${bundleImg}" alt="${bundleTitle}" class="line-item__media rounded-xs">
      <pill-loader class="pill-loader">
        <div class="loader-dots">
          <span></span>
          <span></span>
          <span></span>
        </div>
        <svg class="loader-checkmark" fill="none" width="9" height="8" viewBox="0 0 9 8">
          <path d="M1 3.5 3.3 6 8 1" stroke="currentColor" stroke-width="2"></path>
        </svg>
      </pill-loader>
    </div>
    <div class="line-item__info">
      <div class="v-stack gap-0.5">
        <a href="${bundleUrl}" class="bold">
        <span class="reversed-link hover:show">${bundleTitle}</span>
        </a>
        <price-list class="price-list  ">
          <sale-price class="text-on-sale">
            <span class="sr-only">Sale price</span>${bundleSalePrice}
          </sale-price>
          <compare-at-price class="text-subdued line-through">
            <span class="sr-only">Regular price</span>${bundleSlashedOutPrice}
          </compare-at-price>
        </price-list>
      </div>
      <div class="text-sm text-subdued sm:hidden">
        <line-item-quantity class="h-stack justify-center gap-3">
          <span is="input-number" class="quantity-input quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
            item.quantity
          }</span>
          <span class="text-xs">
          <a href="javascript:void(0)" class="link line-item__remove-button">Remove</a>
          </span>
        </line-item-quantity>
      </div>
      <ul class="contents" role="list">
      <li class="badge">
      <svg role="presentation" fill="none" focusable="false" stroke-width="1" width="14" height="13" class="icon icon-discount" viewBox="0 0 14 13">
        <path d="M7.25 11.383a1.74 1.74 0 0 0 2.195.105c.478-.35.957-.722 1.39-1.155.433-.433.804-.912 1.154-1.39.486-.662.45-1.588-.104-2.195a65.945 65.945 0 0 0-4.97-4.896 1.588 1.588 0 0 0-.75-.377c-1.017-.197-3.552-.613-4.177.012-.625.624-.208 3.16-.011 4.176.055.28.186.537.376.75a65.976 65.976 0 0 0 4.896 4.97Z" fill="none" stroke="currentColor"></path>
        <path d="M5.729 5.227a1.036 1.036 0 1 0-1.466-1.466 1.036 1.036 0 0 0 1.466 1.466Z" fill="currentColor"></path>
      </svg>
      ${bundleOffValue}
    </li>
      <div class="rebuy-cart__flyout-item-properties">
      <span>Bundle Products</span>
      ${bundleProductsTitleProp(item)}
       </div>
      </ul>
    </div>
  </line-item>
</td>
        
        <td class="hidden align-center text-center text-subdued sm:table-cell">
            <line-item-quantity class="v-stack justify-center gap-2">
            <span is="input-number" class="quantity-input quantity-selector__input text--xsmall" autocomplete="off" type="text" inputmode="numeric" name="updates[]" data-line="1" size="2" aria-label="Change quantity" data-gaconnector-tracked="true">${
              item.quantity
            }</span>
            <span class="text-xs">
                <a href="javascript:void(0)" class="link line-item__remove-button">Remove</a>
            </span>
            </line-item-quantity>
        </td>
		<td class="hidden align-center text-subdued text-end sm:table-cell">${bundleSalePrice}</td>
   `;
}

function bundleLineItemMarkup(item) {
  const bundleCodeProp = item.properties["_bundle_hash"];
  const bundleTitle = item.properties["_bundle_title"];
  const bundleSlashedOutPrice = item.properties["_bundle_slashed_out_price"];
  const bundleSalePrice = item.properties["_bundle_sale_price"];
  let bundleOffValue = item.properties["_bundle_off_value"];
  const bundleImg = item.properties["_bundle_img"];
  const bundleUrl = item.properties["_bundle_url"];

  function bundleProductsTitleProp(item) {
    var string = "";
    for (const [key, value] of Object.entries(
      item.properties["_bundle_products"]
    )) {
      const formattedKey =
        "Bundle " +
        key.charAt(0).toUpperCase() +
        key.slice(1).replace(/_/g, " ");
      if (key.includes("product") && value) {
        let propertyString = `
        <div class="rebuy-cart__flyout-item-property"><span class="rebuy-cart__flyout-item-property-name">${formattedKey}</span> <span class="rebuy-cart__flyout-item-property-separator">
          -
          </span> <span class="rebuy-cart__flyout-item-property-value">${value}</span>
        </div>
        `;
        string = string.concat(propertyString);
      }
    }
    return string;
  }

  return `
      <div class="rebuy-cart__flyout-item-media">
        <a href="${bundleUrl}" tabindex="-1">
          <img src="${bundleImg} alt="${bundleTitle}"></a>
      </div>
      <div class="rebuy-cart__flyout-item-info">
        <a
          role="heading"
          aria-level="5"
          href="${bundleUrl}"
          alt="View ${bundleTitle}"
          class="rebuy-cart__flyout-item-product-title">${bundleTitle}</a>
        <div class="rebuy-cart__flyout-item-discount-message">${bundleOffValue}</div>
        <div class="rebuy-cart__flyout-item-properties">
        ${bundleProductsTitleProp(item)}
      </div>
        <!---->
        <button
          type="button"
          alt="Remove ${bundleTitle}"
          aria-label="Remove ${bundleTitle}"
          class="rebuy-cart__flyout-item-remove line-item__remove-button">
          <i aria-hidden="true" class="far fa-trash"></i>
        </button>
        <div class="rebuy-cart__flyout-item-quantity">
          <div class="rebuy-cart__flyout-item-quantity-widget">
            <button
              alt="Decrease quantity of ${bundleTitle}"
              aria-label="Decrease quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-decrease quantity-selector__button-dec">
              <i aria-hidden="true" class="far fa-minus"></i>
            </button>
            <span class="rebuy-cart__flyout-item-quantity-widget-label quantity-selector__input">
              ${item.quantity}
            </span>
            <button
              alt="Increase quantity of ${bundleTitle}"
              aria-label="Increase quantity of ${bundleTitle}"
              type="button"
              class="rebuy-cart__flyout-item-quantity-widget-button quantity-button-increase quantity-selector__button-inc">
              <i aria-hidden="true" class="far fa-plus"></i>
            </button>
          </div>
        </div>
        <div class="rebuy-cart__flyout-item-price">
          <div>
            <span class="rebuy-money sale">
              <span class="sr-only">Sale price</span>
              <span>${bundleSalePrice}</span>
            </span>
            <span class="rebuy-money compare-at">
              <span class="sr-only">Original price</span>
              <span>${bundleSlashedOutPrice}</span>
            </span>
          </div>
          <!---->
        </div>
        <!---->
      </div>
  `;
}

async function getbundleProducts(bundleProp, bundleId) {
  const { items } = await fetchCart();
  let bundleProducts = [];
  items.map((item) => {
    if (item.properties[bundleProp] == bundleId) {
      bundleProducts.push(item);
    }
  });
  return bundleProducts;
}

function updateLineItemWithQty(bundleProducts, qty) {
  return new Promise((resolve, reject) => {
    if (!bundleProducts.length) return resolve(); // Resolve immediately if no products

    qty = parseInt(qty);
    const newObj = {};
    bundleProducts.forEach((item) => {
      newObj[item.key.toString()] = qty;
    });

    jQuery
      .post(window.Shopify.routes.root + "cart/update.js", {
        updates: newObj,
      })
      .done(() => {
        // updateSubtotalPrices();
        resolve(); // Resolve when request is successful
      })
      .fail((error) => {
        //console.log(error);
        reject(error); // Reject on error
      });
  });
}

async function attachELToLineItem() {
  let staticLineItems = document.querySelectorAll(".static-line-item");
  for (let i = 0; i < staticLineItems.length; i++) {
    const lineItem = staticLineItems[i];
    let removeBtns = lineItem.querySelectorAll(".line-item__remove-button");
    let qtyIncBtns = lineItem.querySelectorAll(
      ".quantity-selector__button-inc"
    );
    let qtyDecBtns = lineItem.querySelectorAll(
      ".quantity-selector__button-dec"
    );
    let qtyTexts = lineItem.querySelectorAll(".quantity-selector__input");
    let lineBundleId = lineItem.id;
    let bundleProp = lineItem.dataset.type;

    removeBtns.forEach((removeBtn) => {
      if (!removeBtn.hasAttribute("data-listener-attached")) {
        removeBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(
            bundleProp,
            lineBundleId
          );
          //console.log("click remove", event.target, bundleProp, lineBundleId, bundleProducts);
          try {
            await updateLineItemWithQty(bundleProducts, 0);
            lineItem.remove();
          } catch (error) {
            //console.log("Error updating quantity:", error);
          }
        });
        removeBtn.setAttribute("data-listener-attached", "true");
      }
    });

    qtyIncBtns.forEach((qtyIncBtn) => {
      if (!qtyIncBtn.hasAttribute("data-listener-attached")) {
        qtyIncBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(
            bundleProp,
            lineBundleId
          );
          //console.log("click Inc", event.target, bundleProp, lineBundleId, bundleProducts);
          let qtyTextInt = parseInt(qtyTexts[0].innerText) + 1;

          try {
            await updateLineItemWithQty(bundleProducts, qtyTextInt);
            qtyTexts.forEach((qtyTxt) => {
              qtyTxt.innerText = qtyTextInt;
            });
          } catch (error) {
            //console.log("Error updating quantity:", error);
          }
        });
        qtyIncBtn.setAttribute("data-listener-attached", "true");
      }
    });

    qtyDecBtns.forEach((qtyDecBtn) => {
      if (!qtyDecBtn.hasAttribute("data-listener-attached")) {
        qtyDecBtn.addEventListener("click", async function (event) {
          const bundleProducts = await getbundleProducts(
            bundleProp,
            lineBundleId
          );
          //console.log("click dec", event.target, bundleProp, lineBundleId, bundleProducts);
          let qtyTextInt = parseInt(qtyTexts[0].innerText) - 1;

          try {
            await updateLineItemWithQty(bundleProducts, qtyTextInt);
            if (qtyTextInt == 0) {
              lineItem.remove();
            } else {
              qtyTexts.forEach((qtyTxt) => {
                qtyTxt.innerText = qtyTextInt;
              });
            }
          } catch (error) {
            //console.log("Error updating quantity:", error);
          }
        });
        qtyDecBtn.setAttribute("data-listener-attached", "true");
      }
    });
  }
}

document.addEventListener("rebuy:smartcart.show", (event) => {
  setTimeout(() => {
    const { items } = Rebuy.Cart.cart;
    if (items.some((item) => item.properties?.["_bundle_id"])) {
      renderStarterKitLineItems();
    }
  }, 1000);
});

const bundleATCBtn = document.querySelector(".bundle-add-to-cart__btn");
if (bundleATCBtn) {
  bundleATCBtn.addEventListener("click", function () {
    setTimeout(async () => {
      await renderBundleLineItems();
    }, 2000);
  });
}

if (isCartPage) {
  (async () => {
    const cart = await fetchCart();
    if (cart.items.some((item) => item.properties?.["_bundle_id"])) {
      await renderStarterKitLineItems();
    }
    if (cart.items.some((item) => item.properties?.["_bundle_hash"])) {
      await renderBundleLineItems();
    }
    if (cart.items.some((item) => item.properties?.["_fp_id"])) {
      await renderFpLineItems();
    }
  })();
} else {
  document.addEventListener("rebuy:smartcart.ready", async () => {
    const { items } = Rebuy.Cart.cart;
    if (items.length) {
      if (items.some((item) => item.properties?.["_bundle_id"])) {
        await renderStarterKitLineItems();
      }
      if (items.some((item) => item.properties?.["_bundle_hash"])) {
        await renderBundleLineItems();
      }
      if (items.some((item) => item.properties?.["_fp_id"])) {
        await renderFpLineItems();
      }
    }
  });
}
